import React from 'react';
import './PageHero.css';

export const PageHero = ({ title, subtitle, symbol = 'white', testId = 'page-hero' }) => (
  <section className="dark-hero" data-testid={testId}>
    <img
      src="/assets/symbol/symbol-blue.svg"
      alt=""
      className="dark-hero-watermark"
      aria-hidden="true"
    />
    <span className="dark-hero-bracket dark-hero-bracket-tr" aria-hidden="true" />
    <span className="dark-hero-bracket dark-hero-bracket-bl" aria-hidden="true" />

    <div className="container dark-hero-inner">
      <img
        src={`/assets/symbol/symbol-${symbol}.svg`}
        alt=""
        className="dark-hero-symbol"
        aria-hidden="true"
      />
      <h1 className="dark-hero-title" data-testid={`${testId}-title`}>{title}</h1>
      {subtitle && <p className="dark-hero-subtitle" data-testid={`${testId}-subtitle`}>{subtitle}</p>}
      <img
        src="/assets/pictos/zigzag.svg"
        alt=""
        className="dark-hero-zigzag"
        aria-hidden="true"
      />
    </div>
  </section>
);

export default PageHero;
